import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import CheckBox from '../../../common/CheckBox/index';
import { Body } from '../../../common/Typography/index';

const AgreementCBox = (props) => {
  const { name, content, id } = props;
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (!isAgreementChecked && document.getElementById(props.textId)) {
      const interval = setInterval(() => {
        document.getElementById(props.textId).addEventListener('scroll', checkScrollHeight(props.textId, interval), false);
      }, 1000);
    }
  }, []);

  const handleCheckbox = (e) => {
    setIsAgreementChecked(e.target.checked);

    props.change(e);
  };

  const checkScrollHeight = (divID, interval) => {
    let agreementTextElement = '';
    if (document.getElementById(divID)) {
      agreementTextElement = document.getElementById(divID);
      if (agreementTextElement && agreementTextElement !== '') {
        if (agreementTextElement.scrollTop + agreementTextElement.offsetHeight >= agreementTextElement.scrollHeight) {
          setIsDisabled(false);
          clearInterval(interval);
        }
      }
    }
  };

  return (
    <div className="agreementCheckBox">
      <CheckBox id={id} name={name} isDisabled={isDisabled} onChange={(e) => handleCheckbox(e)} analyticstrack="5G-agreementCheckbox">
        <Body primitive="p" size="medium">
          {content}
        </Body>
      </CheckBox>
    </div>
  );
};

AgreementCBox.propTypes = {
  name: PropTypes.string,
  content: PropTypes.string,
  change: PropTypes.func,
  id: PropTypes.string,
  textId: PropTypes.string,
};

export default React.memo(AgreementCBox);
